import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import { useTheme } from '../hooks/useTheme';
import { useRouteIsLoading } from 'context/RouteIsLoadingContext';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { isMobileDevice } from 'utils/helpers';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const PageLayout = ({ children, className = '' }) => {
  const { isDarkMode } = useTheme();
  const { isLoading } = useRouteIsLoading();
  const mainRef = useRef(null);

  const location = useLocation();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (!isMobileDevice()) {
        ScrollSmoother.create({
          wrapper: '#smooth-wrapper',
          content: '#smooth-content',
          smooth: 1,
          effects: true,
        });
      }
    }, mainRef);

    return () => ctx.revert();
  }, [location.pathname]);

  useEffect(() => {
    const smoother = ScrollSmoother.get();
    if (smoother) {
      smoother.scrollTo(0, {
        duration: 0,
        ease: 'none',
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  useEffect(() => {
    const preventZoom = (e) => {
      if (e.touches?.length > 1) {
        e.preventDefault();
      }
    };

    const preventGesture = (e) => {
      e.preventDefault();
      document.body.style.zoom = 'reset';
    };
    if (isMobileDevice()) {
      document.addEventListener('touchmove', preventZoom, { passive: false });
      document.addEventListener('gesturestart', preventGesture);
      document.addEventListener('gesturechange', preventGesture);
      document.addEventListener('gestureend', preventGesture);
    }

    return () => {
      if (isMobileDevice()) {
        document.removeEventListener('touchmove', preventZoom);
        document.removeEventListener('gesturestart', preventGesture);
        document.removeEventListener('gesturechange', preventGesture);
        document.removeEventListener('gestureend', preventGesture);
      }
    };
  }, []);

  return (
    <div ref={mainRef}>
      {!isLoading && <Menu />}
      <div
        id='smooth-wrapper'
        className={`page-layout ${isDarkMode ? 'dark' : ''}`}
      >
        <main id='smooth-content' className={`${className}`}>
          {children}
          {!isLoading && <Footer isDarkMode={isDarkMode} />}
        </main>
      </div>
    </div>
  );
};

export default PageLayout;
